import { createSelector } from '@ngrx/store';
import { BankingStateModel, bankingKey } from '@stores/banking/banking-ngrx.reducer';

export const selectBankingState = (state: any): BankingStateModel => state[bankingKey];

export const user = createSelector(selectBankingState, (state) => {
  return state?.user;
});
export const hasFetchBankingUser = createSelector(selectBankingState, (state) => {
  return state?.hasFetchBankingUser;
});
export const bankAccount = createSelector(selectBankingState, (state) => {
  return state?.bankAccount;
});
export const bankInfos = createSelector(selectBankingState, (state) => {
  return state?.bankInfos;
});
export const eligibility = createSelector(selectBankingState, (state) => {
  return state?.eligibility;
});
export const personalInformation = createSelector(selectBankingState, (state) => {
  return state?.personalInformation;
});
export const bankingPartner = createSelector(selectBankingState, (state) => {
  return state?.bankingPartner;
});
